import {Role} from 'web-common/services/auth'

export class RealmRoles {
  static CONTRACTOR: Role = {isRealmRole: true, roleName: 'contractor'}
  static CUSTOMER: Role = {isRealmRole: true, roleName: 'customer'}
  static ADMIN: Role = {isRealmRole: true, roleName: 'admin'}
}
